import React from "react";
import styled from "styled-components";
import { QuoteIcon, CallIcon } from "../Icons";
import QuotePopUpButton from "../QuotePopUpButton";
import DefaultButton from "../Button/DefaultButton";

const FooterStickyCta = styled.div`
  position: fixed;
  z-index: 998;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 15px 0px;
  display: flex;
  @media (min-width: 768px) {
    display: none;
  }
`;
const FooterSticky = styled.div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  a,
  button {
    width: 100%;
    .btn {
      width: 100%;
      border-radius: 0 !important;
    }
  }
`;
const FooterItemSticky = styled.div`
  position: relative;
  width: 100%;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
`;
const FooterSticyBar = () => {
  return (
    <FooterStickyCta className="footer-sticky">
      <FooterSticky>
        <FooterItemSticky className="product-item-cta">
          <a href="tel:2085721441" aria-label="phone number">
            <DefaultButton icon={<CallIcon />} text="(208) 572-1441" size="sm" />
          </a>
        </FooterItemSticky>
        <FooterItemSticky className="product-item-cta">
          <QuotePopUpButton
            thanksURL="/thank-you-product-quote/"
            text="Get a Quote"
            iconAfter={<QuoteIcon />}
            size="sm"
            btnStyle="btnStyle"
          />
        </FooterItemSticky>
      </FooterSticky>
    </FooterStickyCta>
  );
};
export default FooterSticyBar;
